import React, { ReactElement, useEffect } from 'react';
import { useAtom } from 'jotai/index';
import { Strip } from '../../Models/Article';
import { FetchProductAtomV2 } from '../../store/ProductStore';
import { KodanshaReaderComponent } from '../KodanshaReader';
import './ReaderStrip.scss';

interface ReaderStripProps {
    strip: Strip;
}

export function ReaderStrip({ strip: { params } }: ReaderStripProps): ReactElement {
    // @todo define type
    const { productId } = params as { productId: string };
    const [product, fetchProduct] = useAtom(FetchProductAtomV2(parseInt(productId)));

    useEffect(() => {
        (async (): Promise<void> => {
            await fetchProduct(parseInt(productId));
        })();
    }, [fetchProduct, productId]);

    return (
        <div className='ReaderStrip'>
            <KodanshaReaderComponent product={product} isZoomEnabled={false} isEmbed={true} />
        </div>
    );
}
